import {useQuery} from "@tanstack/react-query";
import axiosInstance from "../utilites/axios";
import moment from "moment";
import {endpoints} from "../endpoints/endpoints";

export const useGetPickingList = ({limit}) => {
    return useQuery({
        queryKey: ["pickingList", limit],
        queryFn: async () => {
            return await axiosInstance
                .get(
                    `${endpoints.picking}?limit=100&date=${moment()
                        .tz("America/New_York")
                        .format("yyyy-MM-DD")}`
                ).then((res) => {
                    if (res?.status === 200) {
                        return res?.data;
                    } else {
                        return [];
                    }
                }).catch((e) => {
                });
        },
        refetchInterval: 500 * 10,
        onSuccess: ({data}) => {
            return data;
        }
    });
}

export const useGetPickingDetails = ({uid}) => {
    return useQuery({
        queryKey: ["pickingDetails", uid],
        queryFn: async () => {
            return await axiosInstance.get(
                `${endpoints.picking}/details?uid=${uid}&date=${moment().tz("America/New_York").format("yyyy-MM-DD")}`
            ).then((res) => {
                if (res?.status === 200) {
                    return res?.data;
                } else {
                    return [];
                }
            })
                .catch((e) => {
                    console.log(e);
                })
        },
        enabled: Boolean(uid),
        refetchInterval: 500 * 10,
        onSuccess: ({data}) => {
            return data;
        }
    })
}